/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestedFeedsSkeleton.defs.js'
export * as $defs from './getSuggestedFeedsSkeleton.defs.js'
